import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13.002 19.938a1 1 0 0 0 1.705.77L17 18.413l2.293 2.293a1 1 0 0 0 1.414-1.414L18.413 17l2.293-2.293a1 1 0 0 0-1.414-1.414L17 15.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L15.586 17l-2.293 2.293a1 1 0 0 0-.291.645"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m12.708 16.95-.83-.829a3 3 0 1 1 4.243-4.242l.83.829Q17 12.36 17 12a5 5 0 1 0-4.292 4.95"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M19.938 11A8.001 8.001 0 0 0 4 12a8 8 0 0 0 7 7.938 3 3 0 0 0 .761 2.06C6.35 21.87 2 17.442 2 12 2 6.477 6.477 2 12 2c5.443 0 9.87 4.349 9.997 9.761a3 3 0 0 0-2.059-.76"
    }
  )
);
var SvgRecordingOffOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RecordingOffOutlined_default = SvgRecordingOffOutlined;

export { RecordingOffOutlined_default as default };
